import { render, staticRenderFns } from "./MenuNavigationProvider.vue?vue&type=template&id=611ba076&scoped=true"
import script from "./MenuNavigationProvider.vue?vue&type=script&lang=js"
export * from "./MenuNavigationProvider.vue?vue&type=script&lang=js"
import style0 from "./MenuNavigationProvider.vue?vue&type=style&index=0&id=611ba076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611ba076",
  null
  
)

export default component.exports